import React, { useEffect, useState } from 'react';

import { NButton, NDialog, NInput } from '@innersource-nn/novoui-react';
import { ModalProps } from 'types/Modal';
import useUpdateEnvironment from '../hooks/useUpdateEnvironment';
import NInputWithChips from 'components/Inputs/Labels Input/NInputWithChips';
import NCheckboxTooltip from 'components/Inputs/InputsWithTooltip/NCheckboxTooltip';
import { ModifyEnvironmentInput } from 'types/Environment';
import SimpleLoader from 'components/loader/SimpleLoader';
import NTextAreaQuill from 'components/Inputs/TextAreaQuill/NTextAreaQuill';

const EditEnvironmentModal = ({ visible, onClose }: ModalProps) => {
    const { environment, loading, handleSubmit, updating } =
        useUpdateEnvironment();

    const [formData, setFormData] = useState<ModifyEnvironmentInput>({
        description: environment.description,
        SamlGroupName: environment.originSamlGroupName,

        SamlFullDevGroupName: environment.originSamlFullDevGroupName,
        SamlReaderGroupName: environment.originSamlReaderGroupName,
        identityProviderName: environment.identityProviderName,
        blockpreview: environment.blockpreview,
        quicksight_enabled: environment.quicksight_enabled,
    });
    const updateLabels = (inputName: string, newValue: string[]) => {
        setFormData((prevData: any) => {
            return {
                ...prevData,
                [inputName]: newValue,
            };
        });
    };
    const handleClick = async () => {
        await handleSubmit(formData);
        if (onClose) onClose();
    };

    useEffect(() => {
        setFormData({
            description: environment.description,
            SamlGroupName: environment.originSamlGroupName,
            SamlBasicDevGroupName: environment.originSamlBasicDevGroupName,
            SamlFullDevGroupName: environment.originSamlFullDevGroupName,
            SamlReaderGroupName: environment.originSamlReaderGroupName,
            identityProviderName: environment.identityProviderName,
            blockpreview: environment.blockpreview,
            quicksight_enabled: environment.quicksight_enabled,
        });
    }, [environment]);

    return (
        <NDialog
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline="Edit environment details"
            primaryLabel="Console"
            size="large"
            showDividers={false}
        >
            <div>
                {loading ? (
                    <SimpleLoader />
                ) : (
                    <div className="flex flex-col gap-16 info-container">
                        <NTextAreaQuill
                            label="Environment description"
                            placeholder="Environment description..."
                            variant="outline"
                            modelValue={formData.description}
                            onChange={(value) =>
                                setFormData({
                                    ...formData,
                                    description: value,
                                })
                            }
                        />
                        <div className="grid grid-cols-2 gap-16">
                            <NInputWithChips
                                label="Admin groups"
                                name="SamlGroupName"
                                labels={formData.SamlGroupName ?? []}
                                content="Add descriptive tags or keywords to categorize your datasets using meaningful words."
                                placeholder="Type and press enter... "
                                modelValue=""
                                updateLabels={updateLabels}
                            />
                            <NInputWithChips
                                label="Developer groups"
                                name="SamlFullDevGroupName"
                                labels={formData.SamlFullDevGroupName ?? []}
                                content="Add descriptive tags or keywords to categorize your datasets using meaningful words."
                                placeholder="Type and press enter... "
                                modelValue=""
                                updateLabels={updateLabels}
                            />
                            <NInputWithChips
                                label="Reader groups"
                                name="SamlReaderGroupName"
                                labels={formData.SamlReaderGroupName ?? []}
                                content="Add descriptive tags or keywords to categorize your datasets using meaningful words."
                                placeholder="Type and press enter... "
                                modelValue=""
                                updateLabels={updateLabels}
                            />
                            <NInput
                                label="Identity Provider Name"
                                variant="outline"
                                placeholder="Identity Provider Name..."
                                modelValue={formData.identityProviderName}
                                className={
                                    formData.SamlReaderGroupName?.length
                                        ? 'mb-32'
                                        : ''
                                }
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        identityProviderName: e.target.value,
                                    })
                                }
                            />
                            <NCheckboxTooltip
                                label="Block preview to all datasets"
                                content="Allows users to glimpse into their environments datasets before requesting for full access to that dataset."
                                name="blockpreview"
                                checkboxSize="medium"
                                checked={environment.blockpreview === 'All'}
                                onChange={() =>
                                    setFormData({
                                        ...formData,
                                        blockpreview:
                                            formData.blockpreview === 'All'
                                                ? 'None'
                                                : 'All',
                                    })
                                }
                            />
                            <NCheckboxTooltip
                                content="Can be enabled to allow Amazon Quicksight to gain access to the tables in your environment."
                                label="Enable quicksight access"
                                name="quicksight_enabled"
                                checkboxSize="medium"
                                checked={formData.quicksight_enabled}
                                onChange={() =>
                                    setFormData({
                                        ...formData,
                                        quicksight_enabled:
                                            !formData.quicksight_enabled,
                                    })
                                }
                            />
                        </div>
                        <div className="flex justify-end">
                            <NButton
                                variant="fill"
                                square
                                isLoading={updating}
                                onClick={handleClick}
                            >
                                Update Environment
                            </NButton>
                        </div>
                    </div>
                )}
            </div>
        </NDialog>
    );
};
export default EditEnvironmentModal;
